import {Component, computed, inject, signal} from '@angular/core';
import {DialogService} from 'primeng/dynamicdialog';
import {MessageService} from 'primeng/api';
import {SidebarNav} from './sidebar-nav/sidebar-nav';
import {SidebarActions} from './sidebar-actions/sidebar-actions';
import {SettingsStore} from '../../../store/settings.store';

@Component({
	selector: 'app-sidebar',
	imports: [
		SidebarNav,
		SidebarActions
	],
	standalone: true,
	host: {
		'class': 'sticky top-0',
		'[class.sidebar-expanded]': 'expanded()'
	},
	template: `
		<div
			class="sidebar-panel flex flex-column justify-content-between h-full surface-50 py-4 px-2 border-1 border-gray-200 border-round-2xl"
			[class.sidebar-panel--expanded]="expanded()">
			<div class="sidebar-logo">
				<img [src]="logoSrc()" alt="logo"
					 style="width: 40px; height: 40px;">
				@if (expanded()) {
					<span class="sidebar-logo__label">Ticket Desk</span>
				}
			</div>
			<app-sidebar-nav [expanded]="expanded()"></app-sidebar-nav>
			<app-sidebar-actions [expanded]="expanded()"></app-sidebar-actions>
		</div>

		<button
			type="button"
			class="sidebar-trigger"
			[class.sidebar-trigger--expanded]="expanded()"
			(click)="toggleExpanded()"
			[attr.aria-label]="expanded() ? 'Chiudi sidebar' : 'Apri sidebar'"
			[attr.aria-expanded]="expanded()">
			<i [class]="expanded() ? 'pi pi-angle-left' : 'pi pi-angle-right'"></i>
		</button>
	`,
	styleUrl: './sidebar.component.css',
	providers: [DialogService, MessageService]
})
export class SidebarComponent {
	private settingStore = inject(SettingsStore)

	expanded = signal(false)
	logoSrc = computed(() => this.settingStore.darkTheme() ? '/icon_n.png' : '/icon.png')

	toggleExpanded() {
		this.expanded.update(value => !value)
	}
}
